module.exports = __webpack_public_path__ + "images/file_icons_v2/mid-a29a8ce988f58724fd433374dc488db5.svg";